// extracted by mini-css-extract-plugin
module.exports = {"questions":"SearchFAQs_questions__8XOJE"};